import { css } from "@microsoft/fast-element"
import { focusStrokeOuter, getToken, neutralStrokeActive, neutralStrokeRest } from "../../design-tokens";
import { heightNumber, paddingNumber } from "../size";

export const selectableCardStyles = css`
    :host {
        display: inline-flex;
        align-items: center;

        padding: calc(${getToken('space-design-unit')} * 1px) calc(${paddingNumber} * 1px);
        min-height: calc(${heightNumber} * 1px);

        cursor: pointer;

        --card-width: auto;

        border-width: calc(${getToken('space-stroke-width')} * 1px) !important;
        border-color: ${neutralStrokeRest} !important;
    }

    :host(:hover) {
        border-color: ${getToken('color-primary-base')} !important;
    }

    :host(:active) {
        border-color: ${neutralStrokeActive} !important;
    }

    :host([floating-indicator]) {
        margin-top: calc(${getToken('space-design-unit')} * 2px);
        margin-bottom: calc(${getToken('space-design-unit')} * 2px);
    }

    :host([floating-indicator]:focus-visible:not([disabled])) {
        outline: 2px solid ${focusStrokeOuter};
    }

    :host([floating-indicator]) .control {
        position: absolute;
    }

    :host([floating-indicator]:focus-visible:not([disabled])) .control {
        outline: none;
    }

    :host([floating-indicator]:not([aria-checked="true"])) .control {
        display: none;
    }

    :host([floating-indicator*="top"]) .control {
        top: calc(var(--control-size) / -2);
    }

    :host([floating-indicator*="bottom"]) .control {
        bottom: calc(var(--control-size) / -2);
    }

    :host([floating-indicator*="left"]) .control {
        left: calc(var(--control-size) / -2);
    }

    :host([floating-indicator*="right"]) .control {
        right: calc(var(--control-size) / -2);
    }

    :host(:not([floating-indicator])) .control {
        margin-inline-start: calc(${getToken('space-design-unit')} * 2px);
    }

    .label {
        padding: 0;
    }

    ::slotted([slot="start"]) {
        margin-inline-end: calc(${getToken('space-design-unit')} * 2px);
    }

    .end {
        margin-inline-start: auto;
    }

    ::slotted([slot="end"]) {
        margin-left: auto;
        padding-inline-start: calc(${getToken('space-design-unit')} * 2px);
    }
`;
